"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var useDebounce = function (func, wait) {
    var funcRef = React.useRef(func);
    var cancelFunc = React.useRef(null);
    React.useEffect(function () {
        funcRef.current = func;
    }, [func]);
    React.useEffect(function () {
        return function () {
            if (cancelFunc.current) {
                cancelFunc.current();
            }
        };
    }, []);
    return React.useCallback((0, utils_1.debounce)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return funcRef.current.apply(funcRef, args);
    }, wait, function (cancel) { return cancelFunc.current = cancel; }), []);
};
exports.useDebounce = useDebounce;
//# sourceMappingURL=index.js.map